const colors = {
   brandBlue: {
      400: "#07335A",
      500: "#123946",
      600: "#002a3f",
      700: "#001f33",
      800: "#063359",
   },
   brandSlate: {
      100: "#FFFBF3",
      500: "#899CA3",
      600: "#D6D6CF",
   },
   brandBrown: {
      500: "#BBA37F",
   },
};

export default colors;
